import GroupsIcon from '@mui/icons-material/Groups';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import QueryStatsIcon from '@mui/icons-material/QueryStats';

import {AppConfig} from '../../../../lib/AppConfig';
import {AppRouteResource} from '../../../../types/AppRouteResource';

export const workforceMenuItems: AppRouteResource[] = [
  {
    label: 'appHeader.menuLabels.companyAdmin.workforce.dashboard',
    icon: <QueryStatsIcon />,
    navigationPath: AppConfig.COMPANY_WORKFORCE_ANALYSIS_DASHBOARD_PATH,
  },
  {
    label: 'appHeader.menuLabels.companyAdmin.workforce.profiles',
    icon: <GroupsIcon />,
    navigationPath: AppConfig.COMPANY_WORKFORCE_ANALYSIS_PROFILES_PATH,
  },
  {
    label: 'appHeader.menuLabels.companyAdmin.workforce.departmentHealth',
    icon: <MonitorHeartOutlinedIcon />,
    navigationPath: AppConfig.COMPANY_WORKFORCE_ANALYSIS_DEPARTMENT_HEALTH_PATH,
  },
];
